import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 
import axios from "axios";
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const CreateMembership = ({ onMembershipCreated }) => {
  const [formData, setFormData] = useState({
    membership_type: "",
    image: null,
    membership_description: "",
    membership_duration: "",
    selling_price: "",
    discount_price: "",
    benefits: [
      {
        benefit_name: "",
        description: "",
        icon: "",
        is_active: true,
        sort_order: 0
      }
    ]
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      membership_description: value || "",
    }));
  };

  const handleBenefitChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updatedBenefits = [...formData.benefits];
    
    updatedBenefits[index] = {
      ...updatedBenefits[index],
      [name]: type === 'checkbox' ? checked : value
    };
    
    setFormData(prev => ({
      ...prev,
      benefits: updatedBenefits
    }));
  };

  const addBenefit = () => {
    setFormData(prev => ({
      ...prev,
      benefits: [
        ...prev.benefits,
        {
          benefit_name: "",
          description: "",
          icon: "",
          is_active: true,
          sort_order: prev.benefits.length
        }
      ]
    }));
  };


  const removeBenefit = (index) => {
    const updatedBenefits = formData.benefits.filter((_, i) => i !== index);
    setFormData(prev => ({
      ...prev,
      benefits: updatedBenefits
    }));
  };

  console.log("Form Data:", formData); // Debugging line to check form data 

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const data = new FormData();
    data.append("membership_type", formData.membership_type);
    data.append("image", formData.image);
    data.append("membership_description", formData.membership_description);
    data.append("membership_duration", formData.membership_duration);
    data.append("selling_price", formData.selling_price);
    data.append("discount_price", formData.discount_price);
    
    // Benefits সঠিকভাবে append করুন
    formData.benefits.forEach((benefit, index) => {
      data.append(`benefits[${index}][benefit_name]`, benefit.benefit_name);
      data.append(`benefits[${index}][description]`, benefit.description);
      data.append(`benefits[${index}][icon]`, benefit.icon || '');
      data.append(`benefits[${index}][is_active]`, benefit.is_active ? '1' : '0');
      data.append(`benefits[${index}][sort_order]`, benefit.sort_order);
    });
  
    try {
      const response = await axios.post(`${apiUrl}/memberships`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Membership Created Successfully!");
      onMembershipCreated();
    } catch (err) {
      console.error("Error details:", err.response?.data);
      setError(err.response?.data?.message || "Validation failed. Please check all fields.");
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Membership</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit}>
        {/* Basic Membership Info */}
        <div className="mb-6 p-4 border rounded">
          <h3 className="text-lg font-semibold mb-3">Membership Information</h3>
          
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Membership Type*</label>
            <input
              type="text"
              name="membership_type"
              value={formData.membership_type}
              onChange={handleChange}
              className="border w-full p-2 rounded"
              required
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Membership Image*</label>
            <input
              type="file"
              name="image"
              onChange={handleChange}
              className="border w-full p-2 rounded"
              accept="image/*"
              required
            />
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Description*</label>
            <ReactQuill
              value={formData.membership_description || ""}
              onChange={handleQuillChange}
              className="border rounded"
              modules={{
                toolbar: [
                  [{ 'header': [1, 2, false] }],
                  ['bold', 'italic', 'underline', 'strike'],
                  [{'list': 'ordered'}, {'list': 'bullet'}],
                  ['link', 'image'],
                  ['clean']
                ],
              }}
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-gray-700 mb-1">Duration*</label>
              <input
                type="text"
                name="membership_duration"
                value={formData.membership_duration}
                onChange={handleChange}
                className="border w-full p-2 rounded"
                placeholder="e.g. 12 months"
                required
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-gray-700 mb-1">Selling Price (Tk)*</label>
              <input
                type="number"
                name="selling_price"
                value={formData.selling_price}
                onChange={handleChange}
                className="border w-full p-2 rounded"
                min="0"
                required
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-gray-700 mb-1">Discount Price (Tk)*</label>
              <input
                type="number"
                name="discount_price"
                value={formData.discount_price}
                onChange={handleChange}
                className="border w-full p-2 rounded"
                min="0"
                required
              />
            </div>
          </div>
        </div>
        
        {/* Benefits Section */}
        <div className="mb-6 p-4 border rounded">
          <div className="flex justify-between items-center mb-3">
            <h3 className="text-lg font-semibold">Membership Benefits</h3>
            <button 
              type="button" 
              onClick={addBenefit}
              className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-sm"
            >
              Add Benefit
            </button>
          </div>
          
          {formData.benefits.map((benefit, index) => (
            <div key={index} className="mb-4 p-3 border rounded bg-gray-50">
              <div className="flex justify-between items-center mb-2">
                <h4 className="font-medium">Benefit #{index + 1}</h4>
                {formData.benefits.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeBenefit(index)}
                    className="text-red-600 hover:text-red-800 text-sm"
                  >
                    Remove
                  </button>
                )}
              </div>
              
              <div className="grid grid-cols-2 gap-4 mb-3">
                <div>
                  <label className="block text-gray-700 text-sm mb-1">Benefit Name*</label>
                  <input
                    type="text"
                    name="benefit_name"
                    value={benefit.benefit_name}
                    onChange={(e) => handleBenefitChange(index, e)}
                    className="border w-full p-2 rounded text-sm"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 text-sm mb-1">Icon (React class: MdVerified, FaCrown, BsBullseye etc.. )</label>
                  <input
                    type="text"
                    name="icon"
                    value={benefit.icon}
                    onChange={(e) => handleBenefitChange(index, e)}
                    className="border w-full p-2 rounded text-sm"
                    placeholder="e.g. MdVerified, FaCrown, BsBullseye, etc."
                  />
                </div>
              </div>
              
              <div className="mb-3">
                <label className="block text-gray-700 text-sm mb-1">Description*</label>
                <textarea
                  name="description"
                  value={benefit.description}
                  onChange={(e) => handleBenefitChange(index, e)}
                  className="border w-full p-2 rounded text-sm"
                  rows="2"
                  required
                />
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 text-sm mb-1">Sort Order</label>
                  <input
                    type="number"
                    name="sort_order"
                    value={benefit.sort_order}
                    onChange={(e) => handleBenefitChange(index, e)}
                    className="border w-full p-2 rounded text-sm"
                    min="0"
                  />
                </div>
                
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="is_active"
                    id={`is_active_${index}`}
                    checked={benefit.is_active}
                    onChange={(e) => handleBenefitChange(index, e)}
                    className="mr-2"
                  />
                  <label htmlFor={`is_active_${index}`} className="text-gray-700 text-sm">
                    Active Benefit
                  </label>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <button
          type="submit"
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 w-full"
        >
          Create Membership Package
        </button>
      </form>
    </div>
  );
};

export default CreateMembership;